<template>
  <!-- content -->
  <div class="content">
    <section class="date">{{ this.time || '' }}</section>
    <section class="main">
      <div class="main-content">
        <section
          class="all"
          v-for="(item, index) in anionList"
          :key="item.name"
        >
          <div :class="'div' + index">
            <div class="title">
              <span class="rank">0{{ +index + 1 }}</span>
              <h4 class="name">{{ item.anionTypeName || '' }}</h4>
              <div class="level">
                <span>{{ item.grade || '' }}</span>
                <img :src="getLevelImg(item.grade)" />
              </div>
            </div>
            <div class="anion_value">
              <div>
                <span class="number">{{ item.maxValue || 0 }}</span>
                <span class="text">最大值</span>
              </div>
              <div>
                <span class="number">{{ item.averageValue || 0 }}</span>
                <span class="text">平均值</span>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="average title">
        <span
          >重点公园景区平均值
          <span class="n">N</span>
          <span class="unit">(个/cm³)</span>
          <span class="number">{{ average.val || 0 }}</span></span
        >
        <div class="level">
          <span>{{ average.level }}</span>
          <img :src="getLevelImg(average.level)" />
        </div>
      </div>
    </section>
    <ul class="tip">
      <li class="item">
        <span class="level">等级</span>
        <span class="anion"
          >空气负(氧)离子浓度N(<span class="unit">个/cm³</span>)</span
        >
        <span class="text">说明</span>
      </li>
      <li v-for="item in anionTipList" :key="item.level" class="item">
        <span class="level">
          <span class="level_name">{{ item.level }}</span>
          <img :src="item.img" class="icon" />
        </span>
        <span class="anion">{{ item.concentration }}</span>
        <span class="text">{{ item.text }}</span>
      </li>
    </ul>
    <section class="btm_tip">
      相关数据参考《空气负(氧)离子浓度等级》（QX/T 380-2017）
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import { getServeTime } from '@/utils/time'
export default {
  data() {
    return {
      //http://10.201.64.7:8668
      apiUrl: '/api-air-quality/tokens/anion-data/list', //api地址
      apiTime: '',
      anionList: [],
      time: '',
      loading: '',
      anionTipList: [
        {
          level: 'Ⅰ级',
          concentration: 'N≥1200',
          text: '浓度高，空气清新',
          img: require('@/assets/image/level_1.png')
        },
        {
          level: 'Ⅱ级',
          concentration: '500≤N<1200',
          text: '浓度较高，空气较清新',
          img: require('@/assets/image/level_2.png')
        },
        {
          level: 'Ⅲ级',
          concentration: '100≤N<500',
          text: '浓度中，空气一般',
          img: require('@/assets/image/level_3.png')
        },
        {
          level: 'Ⅳ级',
          concentration: '0<N<100',
          text: '浓度低，空气不够清新',
          img: require('@/assets/image/level_4.png')
        }
      ],
      average: {}
    }
  },
  mounted() {
    this.getTime()
    this.getData()
  },
  methods: {
    //获取离子数据
    getData() {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios
        .get(this.apiUrl + `?anionTime=${this.apiTime}`)
        .then(({ data }) => {
          let arr = data.data || []
          this.anionList = arr.slice(0, 5)
          let average = 0
          for (let i of this.anionList) {
            i.averageValue = i.averageValue || 0
            average = +i.averageValue + average
          }
          this.average = { val: parseInt(average / this.anionList.length) }
          if (this.average.val >= 1200) {
            this.average.level = 'Ⅰ级'
          } else if (this.average.val >= 500) {
            this.average.level = 'Ⅱ级'
          } else if (this.average.val >= 100) {
            this.average.level = 'Ⅲ级'
          } else {
            this.average.level = 'Ⅳ级'
          }
          this.average = { ...this.average }
          this.loading.close()
        })
        .catch((e) => {
          this.anionList = [{}, {}, {}, {}, {}]
          this.loading.close()
          this.$message.error('获取数据错误。')
        })
    },
    //获取时间
    getTime() {
      let { apiTime = '', time = '' } = getServeTime()
      this.apiTime = apiTime
      this.time = time
    },
    getLevelImg(level) {
      if (!level) return
      let img = this.anionTipList.find((i) => i.level == level).img
      return img
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:math';
@media screen and (min-width: 350px) and (max-width: 1200px) {
  $designWidth: 1080;
  $designHeight: 1920;
  @function getVw($px) {
    @return math.div($px, $designWidth) * 100vw;
  }
  @function getVh($px) {
    @return math.div($px, $designHeight) * 100vh;
  }
  .content {
    width: getVw(1080);
    height: getVh(1920);
    margin: 0 auto;
    background-image: url(~@/assets/image/bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: getVh(216) getVw(50) getVh(20) getVw(50);
    box-sizing: border-box;
    overflow: hidden;
    .date {
      width: getVw(354);
      height: getVh(68);
      margin: 0 auto getVh(24) auto;
      background-image: url(~@/assets/image/time.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      color: #fff;
      text-align: center;
      line-height: getVh(68);
      font-size: getVh(32);
    }
    .main {
      width: 100%;
      margin: 0 auto getVh(24) auto;
      border-radius: getVw(22);
      background: rgba(199, 228, 203, 1);
      padding: getVh(22) getVw(22);
      padding-bottom: getVh(2);
      box-sizing: border-box;
      .main-content {
        border-radius: getVw(22);
        background: rgba(255, 255, 255, 1);
        padding: getVh(24) getVw(24);
        .all {
          margin-bottom: getVh(16);
          &:nth-child(1) {
            margin-bottom: getVh(26);
          }

          .title {
            position: relative;
            height: getVh(60);
            background: linear-gradient(
              90deg,
              rgba(195, 232, 200, 1) 0%,
              rgba(195, 232, 200, 1) 68.23%,
              rgba(255, 255, 255, 0) 100%
            );

            padding-left: getVw(24);
            margin-bottom: getVh(8);
            margin-left: getVw(46);
            .rank {
              position: absolute;
              top: getVh(8);
              left: getVw(-40);
              width: getVw(52);
              height: getVh(44);
              background: rgba(170, 204, 174, 1);
              text-align: center;
              line-height: getVh(44);
              color: #fff;
              font-size: getVh(36);
            }
            .name {
              font-size: getVh(40);
              color: rgba(34, 34, 34, 1);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .anion_value {
            height: getVh(110);
            border-radius: getVh(8);
            background: rgba(195, 232, 200, 0.1);
            border: 1px solid rgba(195, 232, 200, 1);
            .number {
              font-size: getVh(40);
            }
            .text {
              font-size: getVh(30);
            }
          }
          > div.div0 {
            .title {
              background: linear-gradient(
                90deg,
                rgba(255, 197, 45, 0.6) 0%,
                rgba(255, 230, 163, 0.44) 79.86%,
                rgba(255, 255, 255, 0) 100%
              );
            }
            .rank {
              background: #ffb12d;
            }
            .anion_value {
              height: getVh(148);
              background: linear-gradient(
                135deg,
                rgba(255, 232, 170, 0.4) 0%,
                rgba(255, 243, 209, 0) 100%
              );
              border: 1px solid rgba(255, 177, 45, 1);
              > div:nth-child(1) {
                position: relative;
                top: getVh(-15);
                .number {
                  font-size: getVh(60);
                }
              }
            }
          }
          > div.div1 {
            .title {
              background: linear-gradient(
                90deg,
                rgba(255, 182, 171, 1) 0%,
                rgba(255, 182, 171, 0.5) 45.79%,
                rgba(255, 255, 255, 0) 100%
              );
            }
            .rank {
              background: #e6a49a;
            }
            .anion_value {
              background: linear-gradient(
                132.77deg,
                rgba(255, 221, 217, 0.4) 0%,
                rgba(255, 197, 189, 0) 100%
              );
              border: 2px solid rgba(255, 182, 171, 0.5);
            }
          }
          > div.div2 {
            .title {
              background: linear-gradient(
                90deg,
                rgba(242, 188, 141, 1) 0%,
                rgba(242, 188, 141, 0.5) 50.65%,
                rgba(255, 255, 255, 0) 100%
              );
            }
            .rank {
              background-color: #d6a984;
            }
            .anion_value {
              background: linear-gradient(
                131.59deg,
                rgba(250, 230, 212, 0.4) 0%,
                rgba(245, 203, 167, 0) 100%
              );
              border: 1px solid rgba(242, 188, 141, 1);
            }
          }
        }
      }
    }
    .average {
      display: flex;
      justify-content: space-between;
      margin-top: getVh(24);
      padding: 0 getVw(24) !important;
      color: rgba(0, 107, 75, 1);
      font-size: getVh(32);
      .n {
        font-size: getVh(28);
      }
      .unit {
        font-size: getVh(24);
      }

      .number {
        font-weight: 700;
        color: rgba(0, 107, 75, 1);
        margin-left: getVw(28);
      }
      .level {
        flex-shrink: 0;
        width: getVw(140);
        justify-content: flex-end;
      }
    }
    .tip {
      width: 100%;
      margin: 0 auto;
      list-style: none;
      .item {
        display: flex;
        height: getVh(64);
        line-height: getVh(64);
        text-align: center;
        border: 1px solid rgba(132, 171, 136, 1);
        border-top: none;
        font-size: getVh(26);
        .unit {
          font-size: getVh(22);
        }
        &:first-child {
          background-color: rgba(199, 228, 203, 1);
          border-radius: getVh(11) getVh(11) 0px 0px;
          border-top: 1px solid rgba(132, 171, 136, 1); //rgba(37, 77, 42, 1);
          font-size: getVh(34);
        }
        &:last-child {
          border-radius: 0px 0px getVh(11) getVh(11);
        }
        > span {
          border-right: 1px solid rgba(132, 171, 136, 1);
          color: rgba(37, 77, 42, 1);
          &:nth-child(3) {
            border: none;
          }
        }
        .level {
          width: getVw(158);
          display: flex;
          align-items: center;
          justify-content: center;
          .level_name {
            width: getVw(60);
          }
          img {
            width: getVw(38);
            height: getVh(38);
            margin-left: getVw(18);
          }
        }
        .anion {
          flex: 1;
        }
        .text {
          width: getVw(300);
        }
      }
    }
    .btm_tip {
      margin-top: getVh(12);
      font-size: getVh(20);
      text-align: center;
    }
  }
  //公用
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: getVw(190);
    margin-bottom: getVh(30);
    .level {
      display: flex;
      align-items: center;
      span {
        font-size: getVh(30);
      }
      img {
        width: getVw(32);
        height: getVh(32);
        margin-left: getVw(10);
      }
    }
  }
  .anion_value {
    width: 100%;
    height: getVh(190);
    display: flex;
    justify-content: space-around;
    border-radius: getVh(12);
    background: linear-gradient(
      135deg,
      rgba(255, 232, 170, 0.4) 0%,
      rgba(255, 243, 209, 0) 100%
    );
    border: 1px solid rgba(255, 177, 45, 1);
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .number {
        font-size: getVh(60);
        font-weight: 600;
        color: rgba(23, 177, 107, 1);
      }
      .text {
        font-size: getVh(36);
      }
    }
  }
}
@media screen and (min-width: 1201px) and (max-width: 4000px) {
  $designWidth: 1920;
  $designHeight: 1080;
  @function getVw($px) {
    @return math.div($px, $designWidth) * 100vw;
  }
  @function getVh($px) {
    @return math.div($px, $designHeight) * 100vh;
  }
  .content {
    width: getVw(1080);
    height: getVh(1920);
    margin: 0 auto;
    background-image: url(~@/assets/image/bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: getVh(216) getVw(50) getVh(20) getVw(50);
    box-sizing: border-box;
    overflow: hidden;
    .date {
      width: getVw(354);
      height: getVh(68);
      margin: 0 auto getVh(24) auto;
      background-image: url(~@/assets/image/time.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      color: #fff;
      text-align: center;
      line-height: getVh(68);
      font-size: getVh(32);
    }
    .main {
      width: 100%;
      margin: 0 auto getVh(24) auto;
      border-radius: getVw(22);
      background: rgba(199, 228, 203, 1);
      padding: getVh(22) getVw(22);
      padding-bottom: getVh(2);
      box-sizing: border-box;
      .main-content {
        border-radius: getVw(22);
        background: rgba(255, 255, 255, 1);
        padding: getVh(24) getVw(24);
        .all {
          margin-bottom: getVh(16);
          &:nth-child(1) {
            margin-bottom: getVh(26);
          }

          .title {
            position: relative;
            height: getVh(60);
            background: linear-gradient(
              90deg,
              rgba(195, 232, 200, 1) 0%,
              rgba(195, 232, 200, 1) 68.23%,
              rgba(255, 255, 255, 0) 100%
            );

            padding-left: getVw(24);
            margin-bottom: getVh(8);
            margin-left: getVw(46);
            .rank {
              position: absolute;
              top: getVh(8);
              left: getVw(-40);
              width: getVw(52);
              height: getVh(44);
              background: rgba(170, 204, 174, 1);
              text-align: center;
              line-height: getVh(44);
              color: #fff;
              font-size: getVh(36);
            }
            .name {
              font-size: getVh(40);
              color: rgba(34, 34, 34, 1);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .anion_value {
            height: getVh(110);
            border-radius: getVh(8);
            background: rgba(195, 232, 200, 0.1);
            border: 1px solid rgba(195, 232, 200, 1);
            .number {
              font-size: getVh(40);
            }
            .text {
              font-size: getVh(30);
            }
          }
          > div.div0 {
            .title {
              background: linear-gradient(
                90deg,
                rgba(255, 197, 45, 0.6) 0%,
                rgba(255, 230, 163, 0.44) 79.86%,
                rgba(255, 255, 255, 0) 100%
              );
            }
            .rank {
              background: #ffb12d;
            }
            .anion_value {
              height: getVh(148);
              background: linear-gradient(
                135deg,
                rgba(255, 232, 170, 0.4) 0%,
                rgba(255, 243, 209, 0) 100%
              );
              border: 1px solid rgba(255, 177, 45, 1);
              > div:nth-child(1) {
                position: relative;
                top: getVh(-15);
                .number {
                  font-size: getVh(60);
                }
              }
            }
          }
          > div.div1 {
            .title {
              background: linear-gradient(
                90deg,
                rgba(255, 182, 171, 1) 0%,
                rgba(255, 182, 171, 0.5) 45.79%,
                rgba(255, 255, 255, 0) 100%
              );
            }
            .rank {
              background: #e6a49a;
            }
            .anion_value {
              background: linear-gradient(
                132.77deg,
                rgba(255, 221, 217, 0.4) 0%,
                rgba(255, 197, 189, 0) 100%
              );
              border: 1px solid rgba(255, 182, 171, 0.5);
            }
          }
          > div.div2 {
            .title {
              background: linear-gradient(
                90deg,
                rgba(242, 188, 141, 1) 0%,
                rgba(242, 188, 141, 0.5) 50.65%,
                rgba(255, 255, 255, 0) 100%
              );
            }
            .rank {
              background-color: #d6a984;
            }
            .anion_value {
              background: linear-gradient(
                131.59deg,
                rgba(250, 230, 212, 0.4) 0%,
                rgba(245, 203, 167, 0) 100%
              );
              border: 1px solid rgba(242, 188, 141, 1);
            }
          }
        }
      }
    }
    .average {
      display: flex;
      justify-content: space-between;
      margin-top: getVh(24);
      padding: 0 getVw(24) !important;
      color: rgba(0, 107, 75, 1);
      font-size: getVh(40);
      .n {
        font-size: getVh(28);
      }
      .unit {
        font-size: getVh(24);
      }
      .number {
        font-weight: 700;
        color: rgba(0, 107, 75, 1);
        margin-left: getVw(28);
      }
    }
    .tip {
      width: 100%;
      margin: 0 auto;
      list-style: none;
      .item {
        display: flex;
        height: getVh(64);
        line-height: getVh(64);
        text-align: center;
        border: 1px solid rgba(132, 171, 136, 1);
        border-top: none;
        font-size: getVh(26);
        .unit {
          font-size: getVh(22);
        }
        &:first-child {
          background-color: rgba(199, 228, 203, 1);
          border-radius: getVh(11) getVh(11) 0px 0px;
          border-top: 1px solid rgba(132, 171, 136, 1); //rgba(37, 77, 42, 1);
          font-size: getVh(34);
        }
        &:last-child {
          border-radius: 0px 0px getVh(11) getVh(11);
        }
        > span {
          border-right: 1px solid rgba(132, 171, 136, 1);
          color: rgba(37, 77, 42, 1);
          &:nth-child(3) {
            border: none;
          }
        }
        .level {
          width: getVw(158);
          display: flex;
          align-items: center;
          justify-content: center;
          .level_name {
            width: getVw(60);
          }
          img {
            width: getVw(38);
            height: getVh(38);
            margin-left: getVw(18);
          }
        }
        .anion {
          flex: 1;
        }
        .text {
          width: getVw(300);
        }
      }
    }
    .btm_tip {
      margin-top: getVh(12);
      font-size: getVh(20);
      text-align: center;
    }
  }
  //公用
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: getVw(190);
    margin-bottom: getVh(30);
    .level {
      display: flex;
      align-items: center;
      span {
        font-size: getVh(30);
      }
      img {
        width: getVw(32);
        height: getVh(32);
        margin-left: getVw(10);
      }
    }
  }
  .anion_value {
    width: 100%;
    height: getVh(190);
    display: flex;
    justify-content: space-around;
    border-radius: getVh(12);
    background: linear-gradient(
      135deg,
      rgba(255, 232, 170, 0.4) 0%,
      rgba(255, 243, 209, 0) 100%
    );
    border: 1px solid rgba(255, 177, 45, 1);
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .number {
        font-size: getVh(60);
        font-weight: 600;
        color: rgba(23, 177, 107, 1);
      }
      .text {
        font-size: getVh(36);
      }
    }
  }
}
</style>
